import { useMutation, useQueryClient } from "@tanstack/react-query";
import BankMpProvider from "@/core/data-provider/data-mp/bank/bank-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { QUERY_KEY_BANK_CHARACTER } from "@/domains/bank/hooks/useBankCharacterQuery";

export function useDepositMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      depositAmount,
      atmId,
      filialId,
    }: {
      depositAmount: number;
      atmId: number | null;
      filialId: number | null;
    }) => {
      const response = await BankMpProvider.deposit({
        depositAmount,
        atmId,
        filialId,
      });

      if (response instanceof RpcMpProviderFailedResponse) {
        throw new Error(response.error?.message);
      }

      return response.data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: [QUERY_KEY_BANK_CHARACTER] });
    },
  });
}
